import { useMemo } from 'react';
import MaintainMessageParser from './MaintainMessageParser';

export default function useParseMaintainMessage({ message }) {
  return useMemo(() => message && new MaintainMessageParser(message).parse(), [message]);
}
